import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { stats } from "../../lib/site";
import { Reveal } from "./Reveal";

const CountUp = ({ value, suffix, testid }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2.2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} data-testid={testid} className="font-display font-light text-6xl sm:text-7xl lg:text-8xl text-brand leading-none">
      {display}{suffix}
    </span>
  );
};

export const Stats = () => (
  <section data-testid="stats-section" className="relative border-y hairline bg-panel/30" aria-label="Studio numbers">
    <div className="max-w-7xl mx-auto grid lg:grid-cols-12">
      <div className="hidden lg:block lg:col-span-3 relative overflow-hidden group">
        <img
          src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=900&q=80&auto=format&fit=crop"
          alt="Web design agency studio team reviewing a client website project in black and white"
          loading="lazy"
          className="img-dual absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div className="lg:col-span-6 px-5 sm:px-10 py-20 sm:py-28">
        <Reveal>
          <p className="eyebrow text-center mb-14" data-testid="stats-eyebrow">Numbers that matter</p>
        </Reveal>
        <div className="space-y-12">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={0.1 * i}>
              <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 border-b hairline pb-8">
                <CountUp value={s.value} suffix={s.suffix} testid={`stat-value-${i}`} />
                <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-mute pb-2">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="hidden lg:block lg:col-span-3 relative overflow-hidden group">
        <img
          src="https://images.pexels.com/photos/7675029/pexels-photo-7675029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700"
          alt="Developer crafting a custom website design for a business client, black and white studio photo"
          loading="lazy"
          className="img-dual absolute inset-0 w-full h-full object-cover"
        />
      </div>
    </div>
  </section>
);
